import { GridApi, IRowNode } from 'ag-grid-community';
import { NodeUtils as PortalNodeUtils } from '@portal-shared/app/utils/node.utils';
import { PlanningRow } from '@shared/components/grids/rows/planning-row';
import { isNil } from 'lodash-es';

export class NodeUtils extends PortalNodeUtils {
  /**
   * A group is droppable if it is the last grouping in the tree.
   * A leafrow is droppable is its `isRowDroppable` property is true.
   */
  public static isCellDroppable(node?: IRowNode<PlanningRow>) {
    if (isNil(node)) return false;
    return !isNil(node.data) && node.data.isRowDroppable;
  }

  public static expandCell(
    node: IRowNode,
    api: GridApi,
    isOpen: boolean,
    options: {
      rowHeightPx: number;
      rowHeightOpenPx: number;
    }
  ) {
    node.setRowHeight(isOpen ? options.rowHeightOpenPx : options.rowHeightPx);

    api.onRowHeightChanged();
  }
}
